window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}
gtag("js", new Date());

const trackGoogleAnalytics = (event) => {
  gtag("config", "G-VB13Y05CMN", {
    cookie_flags: "max-age=7200;secure;samesite=none",
  });
};

document.addEventListener("turbo:load", trackGoogleAnalytics);
